import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, Button, Backdrop } from '@material-ui/core';

import useStyles from './Preview.style';
import { colors } from 'theme/color-palette';
import globalTourIcon from 'assets/svgs/global.svg';
import { TAKE_A_TOUR, TAKE_A_TOUR_DESC, CANCEL, START_TOUR } from 'constants/constant';
import { setStartTour as setStartTourAction } from 'components/UserTour/Tour.action';

const TourStarter = ({ show, onTourStart }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const { isTourFromHelp } = useSelector((state) => state.tourReducer);

	const onCancel = () => {
		dispatch(
			setStartTourAction({
				isFirstTimeUser: false,
				isTourFromHelp: false,
				showTourStarter: false,
				showPreviewElementsTour: false
			})
		);
	};

	return show ? (
		<Backdrop
			style={{
				zIndex: 1202,
				color: colors.PURPLE,
				background: 'rgba(255, 255, 255, 0.8)'
			}}
			open={show}>
			<Box className={classes.tourContainer}>
				<Box>
					<Typography className={classes.tourHeader}>{TAKE_A_TOUR}</Typography>
					<Typography className={classes.tourMsg}>{TAKE_A_TOUR_DESC}</Typography>
				</Box>
				<img className={classes.tourIcon} src={globalTourIcon} alt="Tour icon"></img>
				<Box className={classes.tourBtnWrapper}>
					<Button className={`${classes.tourBtn} ${classes.tourBtnPrimary}`} onClick={onTourStart}>
						{START_TOUR}
					</Button>
					{/* Cancel button will show only in the Help -> Start Tour flow */}
					{isTourFromHelp ? (
						<Button
							className={`${classes.tourBtn} ${classes.tourBtnSecondary}`}
							id="btn-tour-cancel"
							onClick={onCancel}>
							{CANCEL}
						</Button>
					) : null}
				</Box>
			</Box>
		</Backdrop>
	) : null;
};

export default TourStarter;
